import type JCE from '@chesscom/js-chess-engine';
import type { Game } from 'chessboard/model/game/types';
import type { GameAPI } from 'chessboard/types';

export type CanPromoteParams = {
  api: GameAPI;
  node: Game.Move.Node | JCE.Position.Starting;
};

/**
 * Check if `Promote` action should be available
 */
export function canPromote({ api, node }: CanPromoteParams): boolean {
  const lineId = node.ids.line;

  /**
   * If node belongs to the main line already, then it can't be promoted
   */
  if (lineId === 0) {
    return false;
  }

  const line = api.getLine(lineId);

  if (!line) {
    return false;
  }

  const parentLineId = line.parentId;

  /**
   * If node belongs to the line which is direct child of main line,
   * result should depends on `canAddMovesToMainLine` and
   * `canModifyExistingMovesOnMainLine` options
   */
  if (parentLineId === 0) {
    const { canAddMovesToMainLine, canModifyExistingMovesOnMainLine } = api.getMode().getOptions();

    return canAddMovesToMainLine && canModifyExistingMovesOnMainLine;
  }

  /**
   * If node nested more than 1 level deep from main line, it can be promoted
   * despite any other conditions
   */
  return true;
}
